<template>
    <div>
    </div>
</template>

<script>
  import aes from "../../libs/aes";
  export default {
    name: "wechatLogin",
    mounted(){
      this.componentDidMount()
    },
    methods:{
      componentDidMount() {
        var wechatLogin=localStorage.getItem('wechatLogin')
        let state;
        let url=window.location.href;
        let loginURL
        if (localStorage.getItem("logiNType") == 'yes') {
          loginURL = "hcm/wechat/bindByWeiXin"
          if(url.indexOf('gree.olonger')!=-1) state='gree_' + localStorage.getItem("loginUserid")//格力
          if(url.indexOf('console')!=-1) state='brm_u_' + localStorage.getItem("loginUserid")//内部
          if(url.indexOf('brm.olonger')!=-1) state='brm_c_' + localStorage.getItem("loginUserid")//外部
        } else if (localStorage.getItem("logiNType") == 'm') {
          loginURL = "hcm/wechat/bindByWeiXin"
          if(url.indexOf('gree.olonger')!=-1) state='gree_m_' + localStorage.getItem("loginUserid")//格力
          if(url.indexOf('console')!=-1) state='brm_m_' + localStorage.getItem("loginUserid")//内部
          if(url.indexOf('brm.olonger')!=-1) state='brm_m_' + localStorage.getItem("loginUserid")//外部
        } else if (localStorage.getItem("logiNType") == 'no') {
          loginURL = "hcm/wechat/loginByWeiXin"
          if(url.indexOf('gree.olonger')!=-1) state='_gree'//格力
          if(url.indexOf('console')!=-1) state='brm_u'//内部
          if(url.indexOf('brm.olonger')!=-1) state='brm_c'//外部
        }
        console.log('state'+state)
        let params={
          code: aes.getQueryString("code"),
          state:state//brm_u  brm_c _gree
        }
        fetch({
          url: loginURL,
          method: "get",
          params:params,
          noFormat: true,
          responseType: "text"
        }).then((res) => {
          let result=JSON.parse(res)
          if (result.status == '10000') {
            localStorage.setItem('userData',JSON.stringify(result.data))
            localStorage.setItem('token',wechatLogin)
            // if(result.data.logintype=='HCM'||result.data.logintype=='HCMSUB') {
            //     this.$router.replace({path:'/BrandHomepage'})
            // }
            // if(result.data.logintype=='KEFU') {
            //     this.$router.replace({path:'/brmHomepage'})
            // }
            // else if(result.data.logintype=='ADMIN') {
            //     this.$router.replace({path:'/adminHomepage'})
            // } else if (result.data.logintype=='DEALER'||result.data.logintype=='SHOP'){
            //     this.$router.replace({path:'/Dealers'})
            // }

            //测试路由失效问题↓↓
            this.$router.replace({path:'/homeInterim'})
          } else {
            this.$confirm(result.message, '提示', {
              confirmButtonText: '返回登录',
              type: 'warning'
            }).then(() => {
              this.$router.replace({path:'/login'})
            }).catch(()=>{
              this.$router.replace({path:'/login'})
            })
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
